import React, { ChangeEvent } from 'react';
import useAlphabetical from '../../Hooks/useAlphabetical';

interface IBranch {
    branch_id: string;
    name: string;
}

export interface IBranchDropdownProps {
    branches: IBranch[];
    onChange: (event: ChangeEvent) => void;
}

export default function BranchDropdown({ branches, onChange }: IBranchDropdownProps) {
    const sortedBranches = useAlphabetical<IBranch>(branches, "name");

    return (
        <select className="form-control" onChange={onChange}>
            <option value="">All Branches</option>
            {sortedBranches.map(branch => (
                <option key={branch.branch_id} value={branch.branch_id}>{branch.name}</option>
            ))}
        </select>
    );
}
